import React, { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import axios from "axios";

type Avaliacao = {
  id: number;
  usuarioNome: string;
  usuarioFotoUrl?: string;
  nota: number;
  comentario: string;
  data: string;
  fotos?: string[];
};

type Props = {
  pacoteId: number | null;
  open: boolean;
  onClose: () => void;
  baseUrl: string;
};

const PacoteReviewsModal: React.FC<Props> = ({ pacoteId, open, onClose, baseUrl }) => {
  const [avaliacoes, setAvaliacoes] = useState<Avaliacao[]>([]);
  const [loading, setLoading] = useState(false);

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxSlides, setLightboxSlides] = useState<{ src: string }[]>([]);

  const openLightbox = (slides: { src: string }[]) => {
    setLightboxSlides(slides);
    setLightboxOpen(true);
  };

  useEffect(() => {
    if (!pacoteId || !open) return;

    const fetchAvaliacoes = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${baseUrl}/avaliacoes/pacote/${pacoteId}`);
        setAvaliacoes(res.data);
      } catch (err) {
        console.error("Erro ao buscar avaliações:", err);
        setAvaliacoes([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAvaliacoes();
  }, [pacoteId, open, baseUrl]);

  if (!open) return null;

  return (
    <>
      {/* Modal */}
      <div className={`modal fade show d-block`} tabIndex={-1} aria-hidden={!open}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Avaliações do pacote</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              {loading && <p>Carregando...</p>}
              {!loading && avaliacoes.length === 0 && <p>Nenhuma avaliação encontrada.</p>}
              {!loading &&
                avaliacoes.map((av) => (
                  <div key={av.id} className="card mb-2 p-2">
                    <div className="d-flex align-items-center mb-2">
                      <img
                        src={av.usuarioFotoUrl ? `${baseUrl}${av.usuarioFotoUrl}` : "/assets/img/users/default-avatar.png"}
                        className="avatar rounded-circle me-2"
                        alt={av.usuarioNome}
                        style={{ width: "40px", height: "40px" }}
                      />
                      <div>
                        <strong>{av.usuarioNome}</strong>
                        <span className="badge badge-warning badge-xs text-gray-9 fs-10 fw-medium ms-2 p-1">
                          ⭐ {av.nota.toFixed(1)}
                        </span>
                      </div>
                    </div>

                    <p style={{ fontSize: "0.9rem", lineHeight: 1.4 }}>{av.comentario}</p>

                    {av.fotos && av.fotos.length > 0 && (
                      <div className="d-flex flex-wrap gap-2">
                        {av.fotos.map((f, idx) => (
                          <div
                            key={idx}
                            style={{ width: "80px", height: "80px", cursor: "pointer" }}
                            onClick={() =>
                              openLightbox(av.fotos!.map((fid) => ({ src: `${baseUrl}/uploads/${fid}` })))
                            }
                          >
                            <img
                              src={`${baseUrl}/uploads/${f}`}
                              alt="foto"
                              style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "6px" }}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>

      {/* Backdrop escuro */}
      <div className="modal-backdrop fade show"></div>

      {/* Lightbox */}
      <Lightbox open={lightboxOpen} close={() => setLightboxOpen(false)} slides={lightboxSlides} />
    </>
  );
};

export default PacoteReviewsModal;
